import React from 'react';
import './Header.css'


const Header = () => {
    
    // https://i.ibb.co/m99PR11/20221023-181454.jpg
    // https://i.ibb.co/B6ffNPJ/20221023-181555.jpg
    // https://i.ibb.co/gPcVJ3W/20221023-181626.jpg
    // https://i.ibb.co/xM0jdnf/20221023-181748.jpg
    // https://i.ibb.co/0y93cp0/20221023-181819.jpg
    // https://i.ibb.co/hKc9J7Y/20221023-181909.jpg
    return (

        <div class="hero bg-primary style-bg mt-1">
  <div class=""></div>
  <div class="hero-content text-center text-neutral-content">
    
  </div>
</div>
       
    );
};

export default Header;